import Vue from 'vue'
import VueRouter from 'vue-router'
// import App from '../pages/Home.vue'
import { getUesrId } from '../utils/localstorage'

const login = r => require.ensure([], () => r(require('../pages/Login.vue')), 'login')
const home = r => require.ensure([], () => r(require('../pages/Home.vue')), 'home')
const notfound = r => require.ensure([], () => r(require('../views/404.vue')), 'notfound')
const notice = r => require.ensure([], () => r(require('../views/ShowMgt.vue')), 'notice')

const routes = [
  {
    path: '/home',
    name: 'home',
    redirect: '/notice',
    component: home,
    children: [
      {
        path: '/TicketPricesCoverMgtGDS',
        component: resolve => require(['../pages/airways-gds/TicketPricesCoverMgt.vue'], resolve),
        meta: {title: '票价上传统计'}
      },
      {
        path: '/TicketPricesRoundCoverMgt',
        component: resolve => require(['../pages/airways-gds/TicketPricesRoundCoverMgt.vue'], resolve),
        meta: {title: '票价上传统计'}
      },
      {
        path: '/TicketPricesValidFareCoverMgt',
        component: resolve => require(['../pages/airways-gds/TicketPricesValidFareCoverMgt.vue'], resolve),
        meta: {title: '有效票价统计'}
      },
      {
        path: '/TicketPricesValidFareExport',
        component: resolve => require(['../pages/airways-gds/TicketPricesValidFareExport.vue'], resolve),
        meta: {title: '票价导出'}
      },
      {
        path: '/EtermDataExport',
        component: resolve => require(['../pages/airways-gds/EtermDataExport.vue'], resolve),
        meta: {title: '黑屏数据导出'}
      },
      {
        path: '/airLineMgtGDS',
        component: resolve => require(['../pages/airways-gds/AirLineMgt.vue'], resolve),
        meta: {title: '航线管理'}
      },
      {
        path: '/CapChannelMgt',
        component: resolve => require(['../pages/airways-gds/CapChannelMgt.vue'], resolve),
        meta: {title: '抓票渠道管理'}
      },
      {
        path: '/airLineMgtSfc',
        component: resolve => require(['../pages/sfc/AirLineMgt.vue'], resolve),
        meta: {title: '航线管理'}
      },
      {
        path: '/ScanGroupMgt',
        component: resolve => require(['../pages/sfc/ScanGroupMgt.vue'], resolve),
        meta: {title: '降舱监控'}
      },
      {
        path: '/ScanSubtaskMgt',
        name: 'ScanSubtaskMgt',
        component: resolve => require(['../pages/sfc/ScanSubtaskMgt.vue'], resolve),
        meta: {title: '降舱监控子任务'}
      },
      {
        path: '/airwaysAccountMgtGDS',
        component: resolve => require(['../pages/airways-gds/AirwaysAccountMgt.vue'], resolve),
        meta: {title: '航司账号管理'}
      },
      {
        path: '/PassengerLibMgt',
        component: resolve => require(['../pages/airways-gds/PassengerLibMgt.vue'], resolve),
        meta: {title: '乘客库管理'}
      },
      {
        path: '/ContactLibMgt',
        component: resolve => require(['../pages/airways-gds/ContactLibMgt.vue'], resolve),
        meta: {title: '联系人库管理'}
      },
      {
        path: '/ChPayMgt',
        component: resolve => require(['../pages/airways-gds/ChPayMgt.vue'], resolve),
        meta: {title: '春秋商旅卡支付记录'}
      },
      {
        path: '/FareLibBaggageAppendMgt',
        component: resolve => require(['../pages/airways-gds/FareLibBaggageAppendMgt.vue'], resolve),
        meta: {title: '行李加购库'}
      },
      {
        path: '/FareTgtSpecsMultiMgt',
        component: resolve => require(['../pages/airways-gds/FareTgtSpecsMultiMgt.vue'], resolve),
        meta: {title: '行李目标库'}
      },
      {
        path: '/FareLibStopCitiesMgt',
        component: resolve => require(['../pages/airways-gds/FareLibStopCitiesMgt.vue'], resolve),
        meta: {title: '经停信息管理'}
      },
      {
        path: '/FareLibStopCitiesTaskMgt',
        component: resolve => require(['../pages/airways-gds/FareLibStopCitiesTaskMgt.vue'], resolve),
        meta: {title: '经停任务管理'}
      },
      {
        path: '/FareStorageRuleMgt',
        name: 'FareStorageRuleMgt',
        component: resolve => require(['../pages/airways-gds/FareStorageRuleMgt.vue'], resolve),
        meta: {title: '直投入库规则管理'}
      },
      {
        path: '/FareCombineAdjustRuleMgt',
        component: resolve => require(['../pages/airways-gds/FareCombineAdjustRuleMgt.vue'], resolve),
        meta: {title: '入库加价规则管理'}
      },
      {
        path: '/fetchingStrategyMgtGDS',
        component: resolve => require(['../pages/airways-gds/FetchingStrategyMgt.vue'], resolve),
        meta: {title: '抓取策略管理'}
      },
      {
        path: '/fetchingStrategyMgtSfc',
        component: resolve => require(['../pages/sfc/FetchingStrategyMgt.vue'], resolve),
        meta: {title: '抓取策略管理'}
      },
      {
        path: '/WeekPlanRuleResultMgt',
        component: resolve => require(['../pages/sfc/WeekPlanRuleResultMgt.vue'], resolve),
        meta: {title: '班期结果管理'}
      },
      {
        path: '/WeekPlanRuleMgt',
        component: resolve => require(['../pages/sfc/WeekPlanRuleMgt.vue'], resolve),
        meta: {title: '班期规则管理'}
      },
      {
        path: '/FetchingStrategyLook',
        component: resolve => require(['../pages/sfc/FetchingStrategyLook.vue'], resolve),
        meta: {title: '自有抓取策略查看'}
      },
      {
        path: '/DataChannelMgtGDS',
        component: resolve => require(['../pages/airways-gds/DataChannelMgt.vue'], resolve),
        meta: {title: '数据渠道管理'}
      },
      {
        path: '/ticketPriceSeachGDS',
        component: resolve => require(['../pages/policy-gds/TicketPriceSeach_fare.vue'], resolve),
        meta: {title: '票价缓存查询'}
      },
      {
        path: '/ticketPriceSeachSfc',
        component: resolve => require(['../pages/sfc/TicketPriceSeach_fare.vue'], resolve),
        meta: {title: '票价缓存查询'}
      },
      {
        path: '/ticketPriceSeachPolicyGDS',
        component: resolve => require(['../pages/policy-gds/TicketPriceSeach_policy.vue'], resolve),
        meta: {title: '票价投放查询'}
      },
      {
        path: '/TicketPriceSeachbidding',
        component: resolve => require(['../pages/policy-gds/TicketPriceSeach_bidding.vue'], resolve),
        meta: {title: '单次比价工具'}
      },
      {
        path: '/OverallPolicyMgtGDS',
        component: resolve => require(['../pages/policy-gds/OverallPolicyMgt.vue'], resolve),
        meta: {title: '全局政策'}
      },
      {
        name: 'OverallPolicyHistoryMgtGDS',
        path: '/OverallPolicyHistoryMgtGDS',
        component: resolve => require(['../pages/policy-gds/OverallPolicyHistoryMgt.vue'], resolve),
        meta: {title: '全局政策历史记录'}
      },
      {
        path: '/PolicyLibGuestMgt',
        component: resolve => require(['../pages/policy-gds/PolicyLibGuestMgt.vue'], resolve),
        meta: {title: '客规知识库'}
      },
      {
        path: '/PolicyLibBaggageMgt',
        component: resolve => require(['../pages/policy-gds/PolicyLibBaggageMgt.vue'], resolve),
        meta: {title: '行李知识库'}
      },
      {
        path: '/PolicyLibFlightPackingMgt',
        component: resolve => require(['../pages/policy-gds/PolicyLibFlightPackingMgt.vue'], resolve),
        meta: {title: '航班包装知识库'}
      },
      {
        path: '/PolicyFlightBlackListMgt',
        component: resolve => require(['../pages/policy-gds/PolicyFlightBlackListMgt.vue'], resolve),
        meta: {title: '航班黑名单'}
      },
      {
        path: '/PolicyAirlineBlackListMgt',
        component: resolve => require(['../pages/policy-gds/PolicyAirlineBlackListMgt.vue'], resolve),
        meta: {title: '航线黑名单'}
      },
      {
        path: '/salePolicyGDS',
        component: resolve => require(['../pages/policy-gds/SalePolicyMgt.vue'], resolve),
        meta: {title: '政策规则'}
      },
      {
        path: '/SalePolicyNewFrMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewFrMgt.vue'], resolve),
        meta: {title: '航路明细政策'}
      },
      {
        path: '/SalePolicyNewYlxMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewYlxMgt.vue'], resolve),
        meta: {title: '易旅行明细政策'}
      },
      {
        path: '/SalePolicyNewQnryqMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewQnryqMgt.vue'], resolve),
        meta: {title: '去哪儿远期明细政策'}
      },
      {
        path: '/SalePolicyNewWnslMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewWnslMgt.vue'], resolve),
        meta: {title: '蜗牛商旅明细政策'}
      },
      {
        path: '/SalePolicyNewJlyMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewJlyMgt.vue'], resolve),
        meta: {title: '伽利略明细政策'}
      },
      {
        path: '/SalePolicyNewUnMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewUnMgt.vue'], resolve),
        meta: {title: '由你飞飞明细政策'}
      },
      {
        path: '/SalePolicyNewPkMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewPkMgt.vue'], resolve),
        meta: {title: 'PK明细政策'}
      },
      {
        path: '/SalePolicyNewVJMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewVJMgt.vue'], resolve),
        meta: {title: '越捷B2B明细政策'}
      },
      {
        path: '/SalePolicyNewSfcMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewSfcMgt.vue'], resolve),
        meta: {title: '自有数据明细政策'}
      },
      {
        path: '/SalePolicyNewSyMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewSyMgt.vue'], resolve),
        meta: {title: '私有数据明细政策'}
      },
      {
        path: '/SalePolicyNewQnrMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewQnrMgt.vue'], resolve),
        meta: {title: '去哪儿数据明细政策'}
      },
      {
        path: '/SalePolicyNewTfcMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewTfcMgt.vue'], resolve),
        meta: {title: '第三方数据明细政策'}
      },
      {
        path: '/SalePolicyNewCfcMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewCfcMgt.vue'], resolve),
        meta: {title: '自组中转明细政策'}
      },
      {
        path: '/SalePolicyNewRfcMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyNewRfcMgt.vue'], resolve),
        meta: {title: '自组往返明细政策'}
      },
      {
        name: 'AddSalePolicyNew',
        path: '/AddSalePolicyNew',
        component: resolve => require(['../pages/policy-gds/AddSalePolicyNew.vue'], resolve),
        meta: {title: '添加政策规则'}
      },
      {
        name: 'SalePolicyDetailNewMgt',
        path: '/SalePolicyDetailNewMgt',
        component: resolve => require(['../pages/policy-gds/SalePolicyDetailNewMgt.vue'], resolve),
        meta: {title: '政策规则详情'}
      },
      {
        path: '/PolicyOverallMgt',
        component: resolve => require(['../pages/policy-gds/PolicyOverallMgt.vue'], resolve),
        meta: {title: '全局政策规则-自组中转'}
      },
      {
        path: '/PolicyOverallSfcMgt',
        component: resolve => require(['../pages/policy-gds/PolicyOverallSfcMgt.vue'], resolve),
        meta: {title: '全局政策规则-自有'}
      },
      {
        path: '/PolicyOverallVJMgt',
        component: resolve => require(['../pages/policy-gds/PolicyOverallVJMgt.vue'], resolve),
        meta: {title: '全局政策规则-越捷B2B'}
      },
      {
        path: '/PolicyOverallTfcMgt',
        component: resolve => require(['../pages/policy-gds/PolicyOverallTfcMgt.vue'], resolve),
        meta: {title: '全局政策规则-第三方'}
      },
      {
        path: '/PolicyOverallRFCMgt',
        component: resolve => require(['../pages/policy-gds/PolicyOverallRFCMgt.vue'], resolve),
        meta: {title: '全局政策规则-自组往返'}
      },
      {
        path: '/BasePolicyFrMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyFrMgt.vue'], resolve),
        meta: {title: '航路基础规则'}
      },
      {
        path: '/BasePolicyYlxMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyYlxMgt.vue'], resolve),
        meta: {title: '易旅行基础规则'}
      },
      {
        path: '/BasePolicyQnryqMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyQnryqMgt.vue'], resolve),
        meta: {title: '去哪儿远期基础规则'}
      },
      {
        path: '/BasePolicyWnslMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyWnslMgt.vue'], resolve),
        meta: {title: '蜗牛商旅基础规则'}
      },
      {
        path: '/BasePolicyJlyMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyJlyMgt.vue'], resolve),
        meta: {title: '伽利略基础规则'}
      },
      {
        path: '/BasePolicyUnMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyUnMgt.vue'], resolve),
        meta: {title: '由你飞飞基础规则'}
      },
      {
        path: '/BasePolicyPkMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyPkMgt.vue'], resolve),
        meta: {title: 'PK基础规则'}
      },
      {
        path: '/BasePolicyVJMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyVJMgt.vue'], resolve),
        meta: {title: '越捷B2B基础规则'}
      },
      {
        path: '/BasePolicyZYMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicySfcMgt.vue'], resolve),
        meta: {title: '自有基础规则'}
      },
      {
        path: '/BasePolicyCfcMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyCfcMgt.vue'], resolve),
        meta: {title: '自组中转基础规则'}
      },
      {
        path: '/BasePolicyRfcMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyRfcMgt.vue'], resolve),
        meta: {title: '自组往返基础规则'}
      },
      {
        path: '/BasePolicySYMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicySyMgt.vue'], resolve),
        meta: {title: '私有基础规则'}
      },
      {
        path: '/BasePolicyQnrMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyQnrMgt.vue'], resolve),
        meta: {title: '去哪儿基础规则'}
      },
      {
        path: '/BasePolicyTfcMgt',
        component: resolve => require(['../pages/policy-gds/BasePolicyTfcMgt.vue'], resolve),
        meta: {title: '第三方数据基础规则'}
      },
      {
        path: '/AddBasePolicy',
        name: 'AddBasePolicy',
        component: resolve => require(['../pages/policy-gds/AddBasePolicy.vue'], resolve),
        meta: {title: '添加基础规则'}
      },
      {
        path: '/AddBasePolicyDetails',
        name: 'AddBasePolicyDetails',
        component: resolve => require(['../pages/policy-gds/AddBasePolicyDetails.vue'], resolve),
        meta: {title: '基础规则详情'}
      },
      {
        path: '/OtaLaunchWeightDetail',
        name: 'OtaLaunchWeightDetail',
        component: resolve => require(['../pages/system-gds/OtaLaunchWeightDetail.vue'], resolve),
        meta: {title: 'OTA拼接过滤配置'}
      },
      {
        path: '/OtaLaunchWeightDetaiLater',
        name: 'OtaLaunchWeightDetaiLater',
        component: resolve => require(['../pages/system-gds/OtaLaunchWeightDetaiLater.vue'], resolve),
        meta: {title: 'OTA拼接过滤配置'}
      },
      {
        path: '/TcExcelDataExport',
        component: resolve => require(['../pages/policy-gds/TcExcelDataExport.vue'], resolve),
        meta: {title: '同程固舱固价数据导出'}
      },
      {
        path: '/TransferPreRuleMgt',
        name: 'TransferPreRuleMgt',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleMgt.vue'], resolve),
        meta: {title: '自组中转策略管理'}
      },
      {
        path: '/TransferPreRuleDetail',
        name: 'TransferPreRuleDetail',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleDetail.vue'], resolve),
        meta: {title: '自组中转策略详情'}
      },
      {
        path: '/TransferPreRuleAdd',
        name: 'TransferPreRuleAdd',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleAdd.vue'], resolve),
        meta: {title: '添加自组中转策略'}
      },
      {
        path: '/TransferPreRuleReturnMgt',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleReturnMgt.vue'], resolve),
        meta: {title: '自组往返策略管理'}
      },
      {
        path: '/TransferPreRuleManual',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleManual.vue'], resolve),
        meta: {title: '手动自组中转策略'}
      },
      {
        path: '/TransferPreRuleManualReturn',
        component: resolve => require(['../pages/policy-gds/TransferPreRuleManualReturn.vue'], resolve),
        meta: {title: '手动自组往返策略'}
      },
      {
        name: 'SalePolicyDetailMgtGDS',
        path: '/SalePolicyDetailMgtGDS',
        component: resolve => require(['../pages/policy-gds/SalePolicyDetailMgt.vue'], resolve),
        meta: {title: '政策规则详情'}
      },
      {
        name: 'AddSalePolicyGDS',
        path: '/AddSalePolicyGDS',
        component: resolve => require(['../pages/policy-gds/AddSalePolicy.vue'], resolve),
        meta: {title: '添加政策规则'}
      },
      {
        name: 'PrivStockMgtGDS',
        path: '/PrivStockMgtGDS',
        component: resolve => require(['../pages/policy-gds/PrivStockMgt.vue'], resolve),
        meta: {title: '私有票价管理'}
      },
      {
        name: 'AddPrivStock',
        path: '/AddPrivStock',
        component: resolve => require(['../pages/policy-gds/AddPrivStock.vue'], resolve),
        meta: {title: '私有票价数据'}
      },
      {
        name: 'AddPrivStockDaily',
        path: '/AddPrivStockDaily',
        component: resolve => require(['../pages/policy-gds/AddPrivStockDaily.vue'], resolve),
        meta: {title: '私有票价每日规则数据'}
      },
      {
        name: 'AddPrivStockDailyCombine',
        path: '/AddPrivStockDailyCombine',
        component: resolve => require(['../pages/policy-gds/AddPrivStockDailyCombine.vue'], resolve),
        meta: {title: '私有票价拼接数据每日规则数据'}
      },
      {
        name: 'PrivStockDailyMgtGDS',
        path: '/PrivStockDailyMgtGDS',
        component: resolve => require(['../pages/policy-gds/PrivStockDailyMgt.vue'], resolve),
        meta: {title: '私有票价每日规则'}
      },
      {
        name: 'PrivStockDailyCombineMgt',
        path: '/PrivStockDailyCombineMgt',
        component: resolve => require(['../pages/policy-gds/PrivStockDailyCombineMgt.vue'], resolve),
        meta: {title: '私有票价拼接数据每日规则'}
      },
      {
        path: '/orderAllGDS',
        component: resolve => require(['../pages/order-gds/OrderAll.vue'], resolve),
        meta: {title: '全部订单'}
      },
      {
        name: 'MyOrderGDS',
        path: '/MyOrderGDS',
        component: resolve => require(['../pages/order-gds/MyOrder.vue'], resolve),
        meta: {title: '我的订单'}
      },
      {
        name: 'orderPayGDS',
        path: '/orderPayGDS',
        component: resolve => require(['../pages/order-gds/orderPay.vue'], resolve),
        meta: {title: '待同步订单'}
      },
      {
        name: 'orderIssueGDS',
        path: '/orderIssueGDS',
        component: resolve => require(['../pages/order-gds/OrderIssue.vue'], resolve),
        meta: {title: '待出票订单'}
      },
      {
        name: 'orderAlreadyIssueGDS',
        path: '/orderAlreadyIssueGDS',
        component: resolve => require(['../pages/order-gds/OrderAlreadyIssue.vue'], resolve),
        meta: {title: '已出票订单'}
      },
      {
        name: 'OrderCancel',
        path: '/OrderCancel',
        component: resolve => require(['../pages/order-gds/OrderCancel.vue'], resolve),
        meta: {title: '已取消订单'}
      },
      {
        name: 'orderAuxGDS',
        path: '/orderAuxGDS',
        component: resolve => require(['../pages/order-gds/OrderAux.vue'], resolve),
        meta: {title: '辅营订单'}
      },
      {
        name: 'OrderTwoAux',
        path: '/OrderTwoAux',
        component: resolve => require(['../pages/order-gds/OrderTwoAux.vue'], resolve),
        meta: {title: '二次辅营订单'}
      },
      {
        name: 'AddAuxsaleGDS',
        path: '/AddAuxsaleGDS',
        component: resolve => require(['../pages/order-gds/AddAuxsale.vue'], resolve),
        meta: {title: '添加辅营详情'}
      },
      {
        name: 'OrderAuxDetailMgtGDS',
        path: '/OrderAuxDetailMgtGDS',
        component: resolve => require(['../pages/order-gds/OrderAuxDetailMgt.vue'], resolve),
        meta: {title: '辅营详情'}
      },
      {
        name: 'OrderDetailsGDS',
        path: '/OrderDetailsGDS',
        component: resolve => require(['../pages/order-gds/OrderDetails.vue'], resolve),
        meta: {title: '订单详情'}
      },
      {
        name: 'OrderRejectLogMgtGDS',
        path: '/OrderRejectLogMgtGDS',
        component: resolve => require(['../pages/order-gds/OrderRejectLogMgt.vue'], resolve),
        meta: {title: '生单日志'}
      },
      {
        name: 'VerifyStat',
        path: '/VerifyStat',
        component: resolve => require(['../pages/order-gds/VerifyStat.vue'], resolve),
        meta: {title: '验价统计'}
      },
      {
        name: 'IssueStat',
        path: '/IssueStat',
        component: resolve => require(['../pages/order-gds/IssueStat.vue'], resolve),
        meta: {title: '出票统计'}
      },
      {
        name: 'OrderTicketCheckTaskMgt',
        path: '/OrderTicketCheckTaskMgt',
        component: resolve => require(['../pages/order-gds/OrderTicketCheckTaskMgt.vue'], resolve),
        meta: {title: '票号验真'}
      },
      {
        name: 'OrderTicketCheckTaskBaggageMgt',
        path: '/OrderTicketCheckTaskBaggageMgt',
        component: resolve => require(['../pages/order-gds/OrderTicketCheckTaskBaggageMgt.vue'], resolve),
        meta: {title: '行李验真'}
      },
      {
        name: 'OrderTicketCheckTaskRefundMgt',
        path: '/OrderTicketCheckTaskRefundMgt',
        component: resolve => require(['../pages/order-gds/OrderTicketCheckTaskRefundMgt.vue'], resolve),
        meta: {title: '退票验真'}
      },
      {
        name: 'OrderIssueTaskMgt',
        path: '/OrderIssueTaskMgt',
        component: resolve => require(['../pages/order-gds/OrderIssueTaskMgt.vue'], resolve),
        meta: {title: '自动出票'}
      },
      {
        name: 'orderPayTaskMgt',
        path: '/orderPayTaskMgt',
        component: resolve => require(['../pages/order-gds/orderPayTaskMgt.vue'], resolve),
        meta: {title: '待支付任务'}
      },
      {
        name: 'orderCancelTaskMgt',
        path: '/orderCancelTaskMgt',
        component: resolve => require(['../pages/order-gds/orderCancelTaskMgt.vue'], resolve),
        meta: {title: '待取消任务'}
      },
      {
        name: 'OrderChangeTaskMgt',
        path: '/OrderChangeTaskMgt',
        component: resolve => require(['../pages/order-gds/OrderChangeTaskMgt.vue'], resolve),
        meta: {title: '自动改期'}
      },
      {
        name: 'OrderBookingOpenTaskMgt',
        path: '/OrderBookingOpenTaskMgt',
        component: resolve => require(['../pages/order-gds/OrderBookingOpenTaskMgt.vue'], resolve),
        meta: {title: 'OPEN票'}
      },
      {
        name: 'OrderTicketSearchTaskMgt',
        path: '/OrderTicketSearchTaskMgt',
        component: resolve => require(['../pages/order-gds/OrderTicketSearchTaskMgt.vue'], resolve),
        meta: {title: '出票订单查询'}
      },
      {
        name: 'InterfaceAccessStat',
        path: '/InterfaceAccessStat',
        component: resolve => require(['../pages/monitor/InterfaceAccessStat.vue'], resolve),
        meta: {title: '接口调用监控'}
      },
      {
        name: 'PolicyPriceCheck',
        path: '/PolicyPriceCheck',
        component: resolve => require(['../pages/monitor/PolicyPriceCheck.vue'], resolve),
        meta: {title: '政策价格排查'}
      },
      {
        name: 'ServerMgt',
        path: '/ServerMgt',
        component: resolve => require(['../pages/monitor/ServerMgt.vue'], resolve),
        meta: {title: '服务器管理'}
      },
      {
        name: 'ServerRuleAlarmMgt',
        path: '/ServerRuleAlarmMgt',
        component: resolve => require(['../pages/monitor/ServerRuleAlarmMgt.vue'], resolve),
        meta: {title: '服务器报警规则管理'}
      },
      {
        name: 'ServerRealStatus',
        path: '/ServerRealStatus',
        component: resolve => require(['../pages/monitor/ServerRealStatus.vue'], resolve),
        meta: {title: '服务器实时状态'}
      },
      {
        name: 'ServerAlarmRecordDetail',
        path: '/ServerAlarmRecordDetail',
        component: resolve => require(['../pages/monitor/ServerAlarmRecordDetail.vue'], resolve),
        meta: {title: '报警详情'}
      },
      {
        name: 'ServerAlarmMgt',
        path: '/ServerAlarmMgt',
        component: resolve => require(['../pages/monitor/ServerAlarmMgt.vue'], resolve),
        meta: {title: '报警列表'}
      },
      {
        name: 'VerifyFailedAlarmMgt',
        path: '/VerifyFailedAlarmMgt',
        component: resolve => require(['../pages/monitor/VerifyFailedAlarmMgt.vue'], resolve),
        meta: {title: '验价失败报警管理'}
      },
      {
        name: 'ServerModuleMonitor',
        path: '/ServerModuleMonitor',
        component: resolve => require(['../pages/monitor/ServerModuleMonitor.vue'], resolve),
        meta: {title: '服务模块监控'}
      },
      {
        name: 'MonitoringPolicyProductMgt',
        path: '/MonitoringPolicyProductMgt',
        component: resolve => require(['../pages/monitor/MonitoringPolicyProductMgt.vue'], resolve),
        meta: {title: '基础规则一级缓存查询'}
      },
      {
        name: 'FareStatRuleMgt',
        path: '/FareStatRuleMgt',
        component: resolve => require(['../pages/report/FareStatRuleMgt.vue'], resolve),
        meta: {title: '票价趋势规则'}
      },
      {
        name: 'FareTrendStat',
        path: '/FareTrendStat',
        component: resolve => require(['../pages/report/FareTrendStat.vue'], resolve),
        meta: {title: '票价趋势查看'}
      },
      {
        name: 'OTADirectSelfExamine',
        path: '/OTADirectSelfExamine',
        component: resolve => require(['../pages/monitor/OTADirectSelfExamine.vue'], resolve),
        meta: {title: 'OTA直连自测'}
      },
      {
        name: 'VietjetSelfExamine',
        path: '/VietjetSelfExamine',
        component: resolve => require(['../pages/monitor/VietjetSelfExamine.vue'], resolve),
        meta: {title: '越捷接口测试'}
      },
      {
        name: 'ScanOrderTaskMgtGDS',
        path: '/ScanOrderTaskMgtGDS',
        component: resolve => require(['../pages/order-gds/ScanOrderTaskMgt.vue'], resolve),
        meta: {title: '扫降舱'}
      },
      {
        name: 'OccupyOrderTaskMgt',
        path: '/OccupyOrderTaskMgt',
        component: resolve => require(['../pages/order-gds/OccupyOrderTaskMgt.vue'], resolve),
        meta: {title: '官网占座'}
      },
      {
        path: '/paymentAccountGDS',
        component: resolve => require(['../pages/finance-gds/PaymentAccount.vue'], resolve),
        meta: {title: '支付账号管理'}
      },
      {
        path: '/IncomeAccountGDS',
        component: resolve => require(['../pages/finance-gds/IncomeAccount.vue'], resolve),
        meta: {title: '收入账号管理'}
      },
      {
        path: '/PaymentCreditCardGDS',
        component: resolve => require(['../pages/finance-gds/PaymentCreditCard.vue'], resolve),
        meta: {title: '支付信用卡管理'}
      },
      {
        path: '/IssueDailyReportGDS',
        component: resolve => require(['../pages/finance-gds/IssueDailyReport.vue'], resolve),
        meta: {title: '出票日报表'}
      },
      {
        path: '/WorkOrderMgt',
        component: resolve => require(['../pages/workorder/WorkOrderMgt.vue'], resolve),
        meta: {title: '技术工单列表'}
      },
      {
        path: '/WorkOrderDealingMgt',
        component: resolve => require(['../pages/workorder/WorkOrderDealingMgt.vue'], resolve),
        meta: {title: '正在进行'}
      },
      {
        name: 'WorkOrderDetails',
        path: '/WorkOrderDetails',
        component: resolve => require(['../pages/workorder/WorkOrderDetails.vue'], resolve),
        meta: {title: '技术工单详情'}
      },
      {
        name: 'WorkOrderConfirmDetail',
        path: '/WorkOrderConfirmDetail',
        component: resolve => require(['../pages/workorder/WorkOrderConfirmDetail.vue'], resolve),
        meta: {title: '确认技术工单'}
      },
      {
        path: '/MyDealWorkOrderMgt',
        component: resolve => require(['../pages/workorder/MyDealWorkOrderMgt.vue'], resolve),
        meta: {title: '我的处理'}
      },
      {
        path: '/MyCommitWorkOrderMgt',
        component: resolve => require(['../pages/workorder/MyCommitWorkOrderMgt.vue'], resolve),
        meta: {title: '我的提交'}
      },
      {
        path: '/AddDealWorkOrderMgt',
        component: resolve => require(['../pages/workorder/AddDealWorkOrderMgt.vue'], resolve),
        meta: {title: '提交工单'}
      },
      {
        path: '/WorkOrderPanel',
        component: resolve => require(['../pages/workorder/WorkOrderPanel.vue'], resolve),
        meta: {title: '工单进度面板'}
      },
      {
        path: '/airportMgtGDS',
        component: resolve => require(['../pages/system-gds/AirportMgt.vue'], resolve),
        meta: {title: '机场管理'}
      },
      {
        path: '/carrierMgtGDS',
        component: resolve => require(['../pages/system-gds/CarrierMgt.vue'], resolve),
        meta: {title: '航司管理'}
      },
      {
        path: '/carrierMgtSfc',
        component: resolve => require(['../pages/sfc/CarrierMgt.vue'], resolve),
        meta: {title: '航司管理'}
      },
      {
        path: '/currencyMgtGDS',
        component: resolve => require(['../pages/system-gds/CurrencyMgt.vue'], resolve),
        meta: {title: '货币管理'}
      },
      {
        path: '/CurrencyRateMgt',
        name: 'CurrencyRateMgt',
        component: resolve => require(['../pages/system-gds/CurrencyRateMgt.vue'], resolve),
        meta: {title: '汇率管理'}
      },
      {
        path: '/ticketChannelMgtGDS',
        component: resolve => require(['../pages/system-gds/TicketChannelMgt.vue'], resolve),
        meta: {title: '出票渠道管理'}
      },
      {
        path: '/IssueRuleMgtGDS',
        component: resolve => require(['../pages/system-gds/IssueRuleMgt.vue'], resolve),
        meta: {title: '出票规则'}
      },
      {
        name: 'IssueRuleDetailMgtGDS',
        path: '/IssueRuleDetailMgtGDS',
        component: resolve => require(['../pages/system-gds/IssueRuleDetailMgt.vue'], resolve),
        meta: {title: '出票规则详情'}
      },
      {
        path: '/otaMgtGDS',
        component: resolve => require(['../pages/system-gds/OtaMgtGDS.vue'], resolve),
        meta: {title: 'OTA管理'}
      },
      {
        path: '/userMgtGDS',
        component: resolve => require(['../pages/system-gds/UserMgt.vue'], resolve),
        meta: {title: '用户管理'}
      },
      {
        path: '/roleMgtGDS',
        component: resolve => require(['../pages/system-gds/RoleMgt.vue'], resolve),
        meta: {title: '角色管理'}
      },
      {
        path: '/ForgeOrderPassengerMgt',
        component: resolve => require(['../pages/tools/ForgeOrderPassengerMgt.vue'], resolve),
        meta: {title: '刷单配置管理'}
      },
      {
        path: '/PrivStockPolicyExportMgt',
        component: resolve => require(['../pages/tools/PrivStockPolicyExportMgt.vue'], resolve),
        meta: {title: '包机切位政策导出'}
      },
      {
        path: '/SeachFareAnalysisMgt',
        component: resolve => require(['../pages/tools/SeachFareAnalysisMgt.vue'], resolve),
        meta: {title: '搜索分析'}
      },
      {
        path: '/UserLoginLogMgt',
        component: resolve => require(['../pages/tools/UserLoginLogMgt.vue'], resolve),
        meta: {title: '系统登录日志'}
      },
      {
        path: '/KnowledgeLibMgt',
        component: resolve => require(['../pages/tools/KnowledgeLibMgt.vue'], resolve),
        meta: {title: '知识库管理'}
      },
      {
        path: '/AddKnowledgeLib',
        name: 'AddKnowledgeLib',
        component: resolve => require(['../pages/tools/AddKnowledgeLib.vue'], resolve),
        meta: {title: '添加知识库'}
      },
      {
        path: '/KnowledgeLibInfo',
        name: 'KnowledgeLibInfo',
        component: resolve => require(['../pages/tools/KnowledgeLibInfo.vue'], resolve),
        meta: {title: '知识库信息'}
      },
      {
        path: '/NotifyMgt',
        component: resolve => require(['../pages/tools/NotifyMgt.vue'], resolve),
        meta: {title: '系统通知管理'}
      },
      {
        path: '/AddNotify',
        name: 'AddNotify',
        component: resolve => require(['../pages/tools/AddNotify.vue'], resolve),
        meta: {title: '添加系统通知'}
      },
      {
        path: '/NotifyList',
        component: resolve => require(['../pages/tools/NotifyList.vue'], resolve),
        meta: {title: '系统通知列表'}
      },
      {
        path: '/NotifyInfo',
        name: 'NotifyInfo',
        component: resolve => require(['../pages/tools/NotifyInfo.vue'], resolve),
        meta: {title: '系统通知信息'}
      },
      {
        path: '/ConfigMgt',
        component: resolve => require(['../pages/tools/ConfigMgt.vue'], resolve),
        meta: {title: '系统配置管理'}
      },
      {
        path: '/MsgMgt',
        component: resolve => require(['../pages/tools/MsgMgt.vue'], resolve),
        meta: {title: '消息列表'}
      },
      {
        path: '/BiddingRuleMgtGDS',
        component: resolve => require(['../pages/bidding-gds/BiddingRuleMgt.vue'], resolve),
        meta: {title: '批量比价策略'}
      },
      {
        path: '/BiddingTaskStat',
        component: resolve => require(['../pages/bidding-gds/BiddingTaskStat.vue'], resolve),
        meta: {title: '比价优胜率'}
      },
      {
        path: '/AutoParityMgtGDS',
        component: resolve => require(['../pages/bidding-gds/AutoParityMgt.vue'], resolve),
        meta: {title: '批量比价任务'}
      },
      {
        path: '/AutoDifferMgtGDS',
        component: resolve => require(['../pages/bidding-gds/AutoDifferMgt.vue'], resolve),
        meta: {title: '舱差提醒'}
      },
      {
        path: '/AutoParityChildMgtGDS',
        name: 'AutoParityChildMgtGDS',
        component: resolve => require(['../pages/bidding-gds/AutoParityChildMgt.vue'], resolve),
        meta: {title: '比价子任务'}
      },
      {
        path: '/AutoParityChildFailMgt',
        name: 'AutoParityChildFailMgt',
        component: resolve => require(['../pages/bidding-gds/AutoParityChildFailMgt.vue'], resolve),
        meta: {title: '比价失败子任务'}
      },
      {
        path: '/AirportMgtSfc',
        component: resolve => require(['../pages/sfc/AirportMgt.vue'], resolve),
        meta: {title: '机场管理'}
      },
      {
        path: '/Pub2PriMgt',
        name: 'Pub2PriMgt',
        component: resolve => require(['../pages/manual-policy/Pub2PriMgt.vue'], resolve),
        meta: {title: '公转私运价'}
      },
      {
        path: '/PublicMgt',
        name: 'PublicMgt',
        component: resolve => require(['../pages/manual-policy/PublicMgt.vue'], resolve),
        meta: {title: '公布运价'}
      },
      {
        path: '/PrivateMgt',
        name: 'PrivateMgt',
        component: resolve => require(['../pages/manual-policy/PrivateMgt.vue'], resolve),
        meta: {title: '私有运价'}
      },
      {
        path: '/FixedPriceMgt',
        name: 'FixedPriceMgt',
        component: resolve => require(['../pages/manual-policy/FixedPriceMgt.vue'], resolve),
        meta: {title: '固舱固价'}
      },
      {
        path: '/AddPub2Pri',
        name: 'AddPub2Pri',
        component: resolve => require(['../pages/manual-policy/AddPub2Pri.vue'], resolve),
        meta: {title: '公转私运价'}
      },
      {
        path: '/AddPublic',
        name: 'AddPublic',
        component: resolve => require(['../pages/manual-policy/AddPublic.vue'], resolve),
        meta: {title: '公布运价'}
      },
      {
        path: '/AddPrivate',
        name: 'AddPrivate',
        component: resolve => require(['../pages/manual-policy/AddPrivate.vue'], resolve),
        meta: {title: '私有运价'}
      },
      {
        path: '/AddFixedPrice',
        name: 'AddFixedPrice',
        component: resolve => require(['../pages/manual-policy/AddFixedPrice.vue'], resolve),
        meta: {title: '固舱固价'}
      },
      {
        path: '/RealTimeLaunchAirlineMgt',
        component: resolve => require(['../pages/launch/RealTimeLaunchAirlineMgt.vue'], resolve),
        meta: {title: '实时投放航线白名单'}
      },
      {
        path: '/FlightPlanChangeMgt',
        name: 'FlightPlanChangeMgt',
        component: resolve => require(['../pages/afterSale-gds/FlightPlanChangeMgt.vue'], resolve),
        meta: {title: '航变信息管理'}
      },
      {
        path: '/AddFlightPlanChange',
        name: 'AddFlightPlanChange',
        component: resolve => require(['../pages/afterSale-gds/AddFlightPlanChange.vue'], resolve),
        meta: {title: '添加航变信息'}
      },
      {
        path: '/CreateOrderLogMgt',
        name: 'CreateOrderLogMgt',
        component: resolve => require(['../pages/log/CreateOrderLogMgt.vue'], resolve),
        meta: {title: '生单日志查询'}
      },
      {
        path: '/404',
        component: notfound,
        meta: {title: '404'}
      },
      {
        path: '/notice',
        component: notice,
        meta: {title: '通知'}
      }
    ]
  },
  {
    path: '/login',
    component: login
  },
  {
    path: '/404',
    component: notfound,
    name: '',
    hidden: true
  },
  {
    path: '/notice',
    component: notice,
    name: '',
    hidden: true
  },
  {
    path: '/',
    component: home,
    redirect: '/notice'
  },
  {
    path: '*',
    hidden: true,
    redirect: {path: '/404'}
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  const token = getUesrId()
  next()
  if (token) {
    next()
  } else {
    if (to.path !== '/login') {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js